import { createRecord } from '@/entities/shared/record/create-record';
import type { Task } from '../schemas/task';
import { taskSchema } from '../schemas/task';

export async function createTask(data: Partial<Task>): Promise<string> {
  return createRecord('tasks', taskSchema, data);
}
